"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimilarProductsRepository = void 0;
class SimilarProductsRepository {
    constructor() {
        this.localStorageKey = 'similarProducts';
    }
    getAll() {
        try {
            const similarProducts = localStorage.getItem(this.localStorageKey);
            return similarProducts ? JSON.parse(similarProducts) : {};
        }
        catch (error) {
            return {};
        }
    }
    getBySku(sku) {
        try {
            const similarProducts = this.getAll();
            return similarProducts[sku];
        }
        catch (error) {
            console.error('Error getting similar product by SKU:', error);
        }
    }
    add(forProduct, selectedProduct) {
        try {
            const similarProducts = this.getAll();
            similarProducts[forProduct] = selectedProduct;
            this.persist(similarProducts);
        }
        catch (error) {
            console.error('Error adding similar product:', error);
        }
    }
    remove(sku) {
        try {
            const filteredSimilarProducts = this.getAll();
            delete filteredSimilarProducts[sku];
            this.persist(filteredSimilarProducts);
        }
        catch (error) {
            console.error('Error deleting similar product:', error);
        }
    }
    removeAll() {
        try {
            this.persist({});
        }
        catch (error) {
            console.error('Error deleting all similar products:', error);
        }
    }
    persist(similarProducts) {
        try {
            localStorage.setItem(this.localStorageKey, JSON.stringify(similarProducts));
        }
        catch (error) {
            console.error('Error saving similar products:', error);
        }
    }
}
exports.SimilarProductsRepository = SimilarProductsRepository;
